import { render } from "./ExpertStatisticsOutbound.vue?vue&type=template&id=0af797d2"
import script from "./ExpertStatisticsOutbound.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsOutbound.vue?vue&type=script&lang=js"

import "./ExpertStatisticsOutbound.vue?vue&type=style&index=0&id=0af797d2&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__